export default {"src":"/_next/static/media/logout.459d1a93.svg","height":11,"width":15,"blurWidth":0,"blurHeight":0};